module.exports = __webpack_public_path__ + "static/media/Dwarf-Selected.930314bf.png";